import React, { useState } from 'react';
import { toast } from 'react-hot-toast';

import { executeBot } from '../../services/api';
import { DataState } from '../../context/DataProvider';
import Loader2 from '../custom/Loader2';

const ExecutionComponent = ({ botId }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const { userGoogleId } = DataState();

  const handleAsynchronousBotExecution = async () => {
    try {
      setLoading(true);
      await executeBot(botId, userGoogleId);
      // toast.success("Workflow Execution Started");
    } catch (error) {
      setError(error.message || 'An error occurred during execution.');
      toast.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    // <div className="bg-zinc-900 text-white p-2 rounded-lg">
    <div className=" rounded-lg p-2 text-white">
      {loading ? (
        // <div className="flex items-center justify-center text-zinc-400 min-h-4">
        //   {/* <div className="flex items-center justify-center text-zinc-400 min-h-96"> */}
        //   <Loader2 />
        // </div>
        <div className="mt-3 flex justify-end">
          <div className=" rounded-lg px-3 py-1 text-zinc-800">
            <Loader2 />
          </div>
        </div>
      ) : error ? (
        <p className="text-center text-red-500">Error: {error}</p>
      ) : (
        <div className="mt-3 flex justify-end">
          <button
            onClick={() => {
              // fetchSteps();
              handleAsynchronousBotExecution();
            }}
            disabled={loading}
            className="rounded-lg bg-zinc-200 px-3 py-1 text-zinc-800"
          >
            {loading ? 'Executing' : 'Execute'}
          </button>
        </div>
        // <p className="text-center text-zinc-400">No steps available</p>
      )}
    </div>
  );
};

export default ExecutionComponent;
